export enum ShippingLoadSearchTypes {
  All = 'All',
  PendingAdd = 'PendingAdd',
  Posted = 'Posted',
  Booked = 'Booked',
  Delivered = 'Delivered',
}
